var map = {
	"./blog.yml": 74,
	"./cloud.yml": 75,
	"./color.yml": 76,
	"./country.yml": 77,
	"./dio.yml": 78,
	"./doc.yml": 79,
	"./emoji.yml": 80,
	"./git.yml": 81,
	"./icon.yml": 82,
	"./license.yml": 83,
	"./link.yml": 84,
	"./metrics.yml": 85,
	"./people.yml": 86,
	"./soft.yml": 87,
	"./src.yml": 88,
	"./status.yml": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;